export class CONSTANT_URL {
  public static SKS_TERMS_OF_SERVICE = 'https://www.edb.co.jp/smile9_tos4';
  public static MAIN_USER_GUIDE = 'https://www.edb.co.jp/guide';
  public static FSC_USER_GUIDE = 'https://www.edb.co.jp/fsc';
  public static SKS_WEBSITE = 'https://www.edb.co.jp/';
  public static EMP_CSV_MANUAL_URL = 'https://smile9-public-documents.s3-ap-northeast-1.amazonaws.com/%E7%A4%BE%E5%93%A1CSV%E5%8F%96%E8%BE%BC%E4%BB%95%E6%A7%98_ver.1.3.2.xlsx';
}
